var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("k-table", {
        ref: "listaPersonas",
        attrs: {
          params: _vm.params,
          filterStatus: _vm.filterStatus,
          createButton: _vm.createButton,
          editButton: false,
          deleteButton: false,
          path: _vm.url + "/personas/search",
          columns: [
            {
              display: "Identificación",
              value: "identificacion"
            },
            {
              display: "Nombre",
              value: "nombre"
            },
            {
              display: "Contacto",
              value: "contacto"
            }
          ]
        },
        on: { crear: _vm.crear, seleccionar: _vm.seleccionar }
      }),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "80%",
            height: "auto",
            scrollable: true,
            name: "crearPersona"
          }
        },
        [
          _c("persona", {
            attrs: {
              tipoFiltro: _vm.tipoFiltro,
              permiteCrearPersona: "",
              permiteEliminarPersona: false,
              permiteEditarPersona: false,
              searchButton: false
            },
            on: { created: _vm.createdPersona }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Personas")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3cd65ea2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cd65ea2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/personas/ListaPersonas.vue
// module id = 360
// module chunks = 0